import Loader from '@anm/components/Loader';
import {
  absoluteCenter,
  subscriptionModalSectionWrapperStyles
} from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

export const TotalPriceWrapper = styled.div`
  ${subscriptionModalSectionWrapperStyles};
  margin-bottom: 6px;
`;

export const TotalTitle = styled.span`
  font-size: 20px;
  margin: 0 10px 10px;
`;

export const TotalAmount = styled.span`
  font-size: 30px;
  margin: 0 10px 10px;
`;

export const CrossedPrice = styled.span`
  position: relative;
  margin: 0 10px 10px;
  font-size: 30px;
  color: #b2b2bf;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: -5%;
    width: 110%;
    height: 2px;

    background: #ff254e;
    transform: rotate(-20deg);
  }
`;

const transparent = css`
  opacity: 0.3;
`;

export const LoaderWrapper = styled(Loader)`
  ${absoluteCenter};
  transform: none;
  margin-top: -6px;
`;

export const PredictPriceContent = styled.div<{ isPending: boolean }>`
  ${({ isPending }) => isPending && transparent};
`;

const Wrapper = styled.div`
  position: relative;
  min-height: 72px;
`;

export default Wrapper;
